import {ActivatedRoute} from '@angular/router';
import {AssingRecycleFormComponent} from './dialogs/assing-recycle/assign-recycle-form.component';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material';
import {RecycleCommandsService} from '../services/recycle-commands.service';
import {SimpleConfirmActionDialogComponent} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../services/toast-messages.service';
import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {AddNotesCommentsComponent} from './dialogs/add-notes-comments/add-notes-comments.component';

@Component({
  styleUrls: ['./recycle-details.component.scss'],
  templateUrl: './recycle-details.component.html'
})
export class RecycleDetailsComponent implements OnInit {
  private recycleId: number;
  public dataSource: MatTableDataSource<Details>;
  public displayedColumns: string[] = ['serial_number', 'material_id', 'material_name', 'batch_name', 'model_name', 'weight_net', 'is_serial_received', 'phase_description'];
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  public title: string;
  public users: any;
  public responseDetails: any;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private recycleCommandsService: RecycleCommandsService,
              private toastMessagesService: ToastMessagesService) {
    this.users = [];
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe((params) => {
      this.recycleId = params.id;
    });

    this.responseDetails = await this.recycleCommandsService.fetchRecycleCommand(this.recycleId);
    this.title = 'Πληροφορίες εντολής ανακύκλωσης';
    this.dataSource = new MatTableDataSource<Details>();
    this.dataSource.data = [this.responseDetails];
    this.users = await this.recycleCommandsService.fetchUsersForAssign(this.recycleId);
    await this.initUser();
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.responseDetails.id
        }
      ],
      title: this.title
    };
    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];

    const action = {
      function: async () => {
        this.routeRecycleCommand();
      },
      showAction: this.responseDetails.status_id === 1 && this.user.role_alternate_name !== 'transportManager',
      title: `Ανάθεση Εντολής`,
      icon: 'assignment',
      color: 'black',
      tooltip: 'Η εντολή πρέπει να είναι εκκρεμής ή να ανήκετε στον κατάλληλο ρόλο'
    };

    const action1 = {
      function: async () => {
        this.routeRecycleCommand();
      },
      showAction: this.responseDetails.status_id === 10 && this.user.role_alternate_name !== 'transportManager',
      title: `Ενημέρωση Ανάθεσης Εντολής`,
      icon: 'assignment',
      color: 'black',
      tooltip: 'Η εντολή πρέπει να είναι δρομολογημένη ή να ανήκετε στον κατάλληλο ρόλο'
    };

    const action2 = {
      function: async () => {
        this.completeRecycle();
      },
      showAction: this.user.role_alternate_name !== 'transportManager' &&
        (this.responseDetails.status_id === 3 || this.responseDetails.status_id === 10),
      title: `Ολοκλήρωση Εντολής`,
      icon: 'done',
      color: 'green',
      tooltip: 'Η εντολή πρέπει να είναι δρομολογημένη ή προς ολοκλήρωση ή να ανήκετε στον κατάλληλο ρόλο'
    };

    const action3 = {
      function: async () => {
        await this.exportPDF();
      },
      showAction: true,
      title: `Λήψη PDF`,
      icon: 'picture_as_pdf',
      color: '#013e81'
    };

    actions.push(action);
    actions.push(action1);
    actions.push(action2);
    actions.push(action3);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  routeRecycleCommand() {
    const dialog = this.matDialog.open(AssingRecycleFormComponent, {
      data: {
        recycleCommandId: this.recycleId,
        users: this.users,
        userRouted: this.responseDetails.routed_to_user_id ? this.responseDetails.routed_to_user_id : null
      }
    });

    dialog.afterClosed().subscribe(async (response) => {
      if (response) {
        if (response.success) {
          try {
            const model = {
              id: response.id,
              user_id: response.user_id
            };
            await this.recycleCommandsService.assignRecycleCommand(model);
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στις εντολές ανακύκλωσης',
                redirectURL: `recycle`
              }
            });
          } catch (e) {
            this.toastMessagesService.toastErrorMessage(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
          }
        } else {
          this.toastMessagesService.toastErrorMessage(`Η ενημέρωση απέτυχε.`);
        }
      }
    });
  }

  private async exportPDF() {
    try {
      await this.commonService.getPDF(`pdf?model=recycle_command&id=${this.recycleId}`, `Εντολή Ανακύκλωσης - ${this.recycleId}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private completeRecycle() {
    const confirm = this.matDialog.open(AddNotesCommentsComponent, {
      width: '400px',
      height: '400px',
      disableClose: true,
      data: {
        title: 'Καταχώρηση πληροφοριών'
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
         await this.recycleCommandsService.completeRecycleCommand(this.recycleId, result);
         this.matDialog.open(ActionCompletionDialogComponent, {
            data: {
              buttonText: 'Πλοήγηση στις εντολές ανακύκλωσης',
              redirectURL: `recycle`
            }
          });
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

}
